import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosInstance } from 'axios';

export const createEnrollmentInvoiceRequests = (api: AxiosInstance) => ({
	getClassroomInvoices: <Response, Payload>(payload: Payload) =>
		api.post<Response>('enrollment/classroom/invoices', payload),
	getCourseInvoices: <Response, Payload>(payload: Payload) =>
		api.post<Response>('enrollment/course/invoices', payload),
});

type InvoiceRequest<Response, Payload> = (
	payload: Payload
) => Promise<{ data: Response }>;

export const createEnrollmentInvoiceThunks = <
	Response,
	ClassroomPayload,
	CoursePayload
>(
	sliceBaseName: string,
	requests: {
		getClassroomInvoices: InvoiceRequest<Response, ClassroomPayload>;
		getCourseInvoices: InvoiceRequest<Response, CoursePayload>;
	}
) => ({
	getClassroomInvoices: createAsyncThunk<
		Response,
		ClassroomPayload,
		{ rejectValue: string }
	>(`${sliceBaseName}/classroom_invoices`, async (payload) => {
		const { data } = await requests.getClassroomInvoices(payload);
		return data;
	}),
	getCourseInvoices: createAsyncThunk<
		Response,
		CoursePayload,
		{ rejectValue: string }
	>(`${sliceBaseName}/course_invoices`, async (payload) => {
		const { data } = await requests.getCourseInvoices(payload);
		return data;
	}),
});
